import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

const StyledInput = styled(Input)`
  text-align: left;
`

const PROPERTY = "benefitsSchemeName"
const MAX_LENGTH = 44

export const schema = (required) =>
  Validation.string(required ? "admin.companyBenefits.settings.name.validation.text" : null).max(MAX_LENGTH)

class BenefitsSchemeName extends PureComponent {
  static propTypes = {
    required: PropTypes.bool,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    required: true,
    placeholder: "admin.companyBenefits.settings.name.placeholder",
    label: "",
    id: "benefitsSchemeName"
  }

  render() {
    const {required, label, placeholder, value, onChange} = this.props

    return (
      <StyledInput
        name=""
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        validation={schema(required)}
        {...this.props}
        id={id(PROPERTY, this.props)}
      />
    )
  }
}

export default BenefitsSchemeName
